export const networkError =
  "Ett fel inträffade när sidan skulle visas. Vänligen försök igen.";
